import styled from "styled-components"

export const Input = styled.input`
  &[type="text"],
  &[type="email"] {
    background-color: ${(props) => props.theme.colors.webinar.inputBackground};
    border-radius: 0.8rem;
    outline: none;
    border: 1px solid ${(props) => props.theme.colors.webinar.inputBorder};
    padding: 1rem 1.2rem;
    min-height: 3rem;
    color: ${(props) => props.theme.colors.webinar.inputText};
    margin-bottom: 1rem;
    font-size: 1.6rem;
    font-weight: normal;
  }
`
  